import * as React from 'react';
import { secondsToMinutesForMatchTime } from 'easit--utils'
import { observer } from 'mobx-react';

export interface IEventStatusProps {
    mainScore: string;
    stateName: string;
    stateTime: number | null;
    importantResults: {
        id: number;
        score1: string;
        score2: string;
        isGame: boolean,
        isHalf: boolean
    }[]
}

export const EventStatus: React.FC<IEventStatusProps> = observer((props: IEventStatusProps) => {
    return <div className="event-status other-details">
        <span style={{ whiteSpace: "nowrap" }}>{props.stateName}{props.stateTime != null && <>, {secondsToMinutesForMatchTime(props.stateTime)}'</>}&nbsp;-&nbsp;</span>

        {props.importantResults && props.importantResults.length > 0 &&
            <>
                {
                    props.importantResults.map((result, indx) =>
                        <span key={result.id} className={`${indx ? "pl-2" : ""} ${result.isGame ? "currentPeriodPart" : ""} ${result.isHalf ? "halfTime" : ""}`}>{result.score1}:{result.score2}</span>)}
            </>
        }
    </div>
});